import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { RolePermissionKey } from '@/modules/ta/role/role.constants';

export class CategoryOverviewRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const settings = getters.session.getUserSettings();
    return (
      (settings.showCategoriesOverview || settings.showDrilldownsWhenOverviewDisabled) &&
      (settings.hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_ACORN) ||
        settings.hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_RIPLEY))
    );
  }
}
